import React from 'react';
import { Dropdown, Menu, MenuItem, Button, Icon } from 'components';
import styled from 'styled-components';
import { useBreakpoint } from 'hooks';
import { kebabCase } from 'lodash';
import type { JsonObject } from '@/app-package';
import { AppointmentDoc } from '@bb/domain/dist/schemas';
import { useHideChat } from '../../../Router/pages/TourEditPage/hooks';

const DROPDOWN_ITEMS: {
  label: string;
  key: string;
  visible?: (
    appointment: JsonObject<AppointmentDoc> & { orgHasCovidFlag: boolean },
  ) => boolean;
}[] = [
  { label: 'Showing History', key: 'history' },
  { label: 'Email Delivery Log', key: 'email' },
  { label: 'SMS Delivery Log', key: 'sms' },
  { label: 'Push Notification Log', key: 'push' },
  {
    label: 'Agent Feedback',
    key: 'feedback',
    visible: appointment =>
      ['Buyer/Broker', 'Revisit', 'Dual Agency', 'Agent Inspection'].includes(
        appointment?.type,
      ),
  },
  {
    label: 'COVID-19',
    key: 'covid',
    visible: appointment => appointment?.orgHasCovidFlag,
  },
];

const MobileNavDropdown: React.FC<{
  appointment: JsonObject<AppointmentDoc> & { orgHasCovidFlag: boolean };
  setTab: (tab: string) => void;
  tab: string;
}> = ({ appointment, setTab, tab }) => {
  const { md } = useBreakpoint();
  useHideChat(!md);

  return !md ? (
    <Dropdown
      dropdownRender={() => (
        <StyledMenu>
          {DROPDOWN_ITEMS.filter(
            ({ visible }) => !visible || visible(appointment),
          ).map(({ label, key }) => (
            <MenuItem
              key={key}
              onClick={() => {
                setTab(key);
              }}
              data-cy={`options-select-${kebabCase(label)}`}
            >
              {label}
            </MenuItem>
          ))}
        </StyledMenu>
      )}
      placement="bottomLeft"
      trigger={['click']}
      arrow
    >
      <StyledButton data-cy="showing-eyeball-mobile-options">
        {DROPDOWN_ITEMS.find(({ key }) => key === tab)?.label}
        <Icon type={'antdDownOutlined'} />
      </StyledButton>
    </Dropdown>
  ) : null;
};

export default MobileNavDropdown;

const StyledButton = styled(Button)`
  border-radius: 2px;
  width: 100%;
  text-align: left;

  & > span {
    width: calc(100% - 18px);
  }

  && ${Icon} {
    display: inline-flex;
    svg {
      width: unset;
      height: unset;
    }
  }
`;

const StyledMenu = styled(Menu)`
  overflow: unset;
  && {
    border-radius: 2px;
    padding: 4px 0px;
  }

  && ${MenuItem} {
    height: 32px;
    border-radius: unset;
  }
`;
